<template>
  <v-data-table
    :loading="loading"
    :headers="computedHeaders"
    :items="notificationsCopy"
    :item-class="getRowClass"
    :items-per-page="5"
    :footer-props="{ 'items-per-page-options': [5, 10, 25, 50 /*-1*/] }"
    class="elevation-1"
  >
    <template v-slot:[`item.id`]="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">
            {{
              item.id.substring(0, 3) +
              '...' +
              item.id.substring(item.id.length - 3)
            }}
          </span>
        </template>
        <div width="300">
          {{ item.id }}
        </div>
      </v-tooltip>
    </template>
    <template v-slot:[`item.fecha_puesta_disposicion`]="{ item }">
      {{ $d(item.fecha_puesta_disposicion, 'i18nDate') }}
    </template>
    <template v-slot:[`item.estado`]="{ item }">
      <template v-if="getNotificationStatus(item).status != ''">
        <v-chip
          class="ma-2 white--text"
          :color="getNotificationStatus(item).color"
        >
          {{ $t(getNotificationStatus(item).status) }}
        </v-chip>
      </template>
    </template>
    <template v-slot:[`item.tipo_envio`]="{ item }">
      <span>
        {{ $t(getNotificationType(item).name) }}
      </span>
    </template>
  </v-data-table>
</template>

<script>
import { getNotificationType } from '@/services/notification-service'
import { mapGetters } from 'vuex'
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    mobileHeaders: {
      type: Array,
      default: () => [],
    },
    notifications: {
      type: Array,
      default: () => [],
    },
    cifs: {
      type: Array,
      default: () => [],
    },
    showHidden: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      notificationsCopy: [],
    }
  },
  methods: {
    /**
     * Shortens the text.
     * @param {String} text Text to shorten.
     * @param {Number} size Size of the text.
     */
    getShortText(text, size = 12) {
      return text.length > size ? text.substring(0, size - 3) + '...' : text
    },
    getNotificationStatus(notification) {
      if (notification.origen == 'DEHUC') {
        notification.estado = 'Comparecida'
        return {
          color: 'appeared',
          status: 'notificationStatus.appeared',
        }
      } else {
        notification.estado = ''
        return {
          color: '',
          status: '',
        }
      }
    },
    getNotificationType(notification) {
      return getNotificationType(notification)
    },
    getRowClass(notification) {
      if (this.cifsMap[notification.nif_titular]?.rejected) {
        return this.$vuetify.theme.dark
          ? 'disabled-row-dark'
          : 'disabled-row-light'
      }
      return ''
    },
    clearTable() {
      this.notificationsCopy = []
    },
  },
  computed: {
    ...mapGetters(['isMobile']),
    computedHeaders() {
      const headers = [
        {
          text: 'ID',
          align: 'start',
          sortable: true,
          value: 'id',
        },
        {
          text: this.$t('company'),
          value: 'nombre_titular',
          width: '40px',
        },
        { text: 'NIF', value: 'nif_titular' },
        {
          text: this.$t('dispatchDate'),
          value: 'fecha_puesta_disposicion',
          width: '20px',
        },
        {
          text: this.$t('notificationProperties.idDehu'),
          value: 'identificador',
        },
        { text: this.$t('state'), value: 'estado' },
        {
          text: this.$t('issuer'),
          value: 'concepto',
          width: '250px',
        },
        {
          text: this.$t('issuingAuthority'),
          value: 'nombre_organismo_emisor',
        },
        {
          text: this.$t('rootAuthority'),
          value: 'nombre_organismo_emisor_raiz',
        },
        { text: this.$t('notificationType'), value: 'tipo_envio' },
      ]

      return this.isMobile && this.mobileHeaders.length > 0
        ? headers.filter((h) => this.mobileHeaders.includes(h.value))
        : headers.filter((h) => this.headers.includes(h.value))
    },
    cifsMap() {
      return (this.cifs || []).reduce((acc, item) => {
        acc[item.cif] = item
        return acc
      }, {})
    },
  },
  watch: {
    notifications: {
      immediate: true,
      handler(nuevos) {
        this.notificationsCopy = nuevos
      },
    },
  },
}
</script>

<style>
.disabled-row-light {
  background-color: #f5f5f5 !important;
  color: #000000de !important;
  pointer-events: none;
  opacity: 0.6;
}
.disabled-row-dark {
  background-color: #2c2c2c !important;
  color: #ffffff !important;
  pointer-events: none;
  opacity: 0.6;
}
</style>
